export default __webpack_public_path__ + "static/media/portfoliocharacter.7c4b0039.png";